"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("../..");

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./SubQuestion.css");

var _styles = {
  "container": "SubQuestion__container___3bA9_",
  "edit-mode": "SubQuestion__edit-mode___3BpAY",
  "no-bg-color": "SubQuestion__no-bg-color___1MVbD",
  "actions": "SubQuestion__actions___fiOCQ",
  "help-link": "SubQuestion__help-link___3zoCO",
  "done-check": "SubQuestion__done-check___3--QR",
  "tooltip": "SubQuestion__tooltip___2MWWq"
};

const styles = _bind.default.bind(_styles);

const SubQuestion = (0, _mobxReact.observer)(({
  className,
  title,
  subtitle,
  showAnswerAsSubtitle,
  dataTestId,
  tooltip,
  setEditMode,
  noBgColor,
  fontSize = 13,
  helpLinkText,
  onHelpLinkClick,
  paddingTopBottom = 8
}) => {
  const composed_classname = (0, _bind.default)(styles('container', {
    'no-bg-color': noBgColor
  }), className);
  return _react.default.createElement(_.Content, {
    dataTestId: dataTestId,
    className: composed_classname,
    flex: true,
    justifyContent: 'space-between',
    paddingTopBottom: paddingTopBottom,
    paddingLeft: 24,
    paddingRight: 32,
    alignItems: 'center'
  }, _react.default.createElement("div", {
    className: styles('info')
  }, _react.default.createElement("div", {
    className: styles('title')
  }, _react.default.createElement(_.Text, {
    text: title,
    size: fontSize,
    variant: 'medium',
    tag: 'span'
  }), tooltip && _react.default.createElement(_.Tooltip, {
    text: tooltip,
    position: 'right',
    className: styles('tooltip')
  }, _react.default.createElement(_.Icon, {
    name: _.IconEnum.question_circle,
    size: 18,
    color: _.Color.blue._60
  }))), _react.default.createElement(_.Content, {
    flex: true,
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 32
  }, (showAnswerAsSubtitle || subtitle) && _react.default.createElement(_.Text, {
    text: showAnswerAsSubtitle ? showAnswerAsSubtitle : subtitle,
    color: _.Color.neutral._80,
    size: fontSize
  }), onHelpLinkClick && _react.default.createElement(_.Button, {
    className: styles('help-link'),
    label: _react.default.createElement(_react.default.Fragment, null, helpLinkText || 'Where to find this information', _react.default.createElement(_.Icon, {
      name: typeof onHelpLinkClick !== 'string' ? _.IconEnum.question_circle : _.IconEnum.external_link,
      size: 18,
      color: _.Color.blue._60
    })),
    variant: 'tertiary',
    onClick: typeof onHelpLinkClick !== 'string' ? () => onHelpLinkClick() : {
      location: onHelpLinkClick,
      external: true
    }
  }))), setEditMode && _react.default.createElement(_.Button, {
    label: 'Edit',
    onClick: () => setEditMode(true),
    variant: 'tertiary',
    dataTestId: `button-${dataTestId}`,
    small: true
  }));
});
var _default = SubQuestion;
exports.default = _default;